import React from 'react';
import { Link } from 'react-router-dom';
import { WEBINAR_LOGOS } from '../../data/webinarCommunications';
import { useWebinar } from '../../hooks/useWebinar';
export function WebinarFooter() {
  const c = useWebinar().copy.footer;
  const closing = c.closing;
  return <footer className="bg-white border-t border-[#E6E7EF]" data-id="element-7893" data-mp="sp2atddvl89u">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8" data-id="element-7894" data-mp="nppfs5cuouw6">
        <div className="flex items-center" data-id="element-7895" data-mp="1ldr4wsgikdc3">
          <img src={WEBINAR_LOGOS.bciti} alt="BCITI" className="h-12 w-auto object-contain" data-id="element-7896" data-mp="1gdv1ovfn4pxl" />
          <span className="mx-2 text-[#121212]/25 font-sans text-xl font-light" aria-hidden="true" data-id="element-7897" data-mp="1blbnbw94pqrq">|</span>
          <img src={WEBINAR_LOGOS.atna} alt="ATNA" className="h-10 w-auto object-contain" data-id="element-7898" data-mp="16lz3zlhgv1tw" />
        </div>
        <p className="font-serif text-[1.15rem] leading-snug text-[#121A3A] md:text-center" data-id="element-7899" data-mp="24366co0434h0">
          {closing[0]}
          <span className="block text-[#4F46E5]" data-id="element-7900" data-mp="1za4ktx5eg6og">{closing[1]}</span>
        </p>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 font-sans text-[13px] text-[#6B7288]" data-id="element-7901" data-mp="36pf9krl3i9r2">
          <span data-id="element-7902" data-mp="3bm5o3ah94xad">{c.rights}</span>
          <Link to="/privacy-policy" className="hover:text-[#4F46E5] transition-colors duration-150" data-id="element-7903" data-mp="3bp9xqndhkl8f">{c.privacy}</Link>
          <Link to="/" className="hover:text-[#4F46E5] transition-colors duration-150" data-id="element-7904" data-mp="31xdyva3ksr35">{c.site}</Link>
        </div>
      </div>
    </footer>;
}